import React from 'react';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';

class Button extends React.PureComponent {

	// The whole meaning of this control, is to force the use of an ID
	// so that we facilitate the job of the QA team
	render() {
		return (<BS.Button {...this.props} />)
	}
}

Button.propTypes = {
  id: PropTypes.string.isRequired
};

export default Button;



// WEBPACK FOOTER //
// ./src/fw/components/button/Button.js